module.exports = __webpack_public_path__ + "img/demonstracao-cardapio-online.77c72baa.jpg";